import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlipNormalsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 19h16M12 19V5M9 8l3-3 3 3M9 16l3 3 3-3" })
});
export default SvgFlipNormalsIcon;
